import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  clearRegisterData,
  registerAccountStore,
} from "../store/slices/accountSlice";

export const SUBSCRIPTION_ROUTE = "/register/subscription";

export const usePremiumUpsellRedirect = (user) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    const registeredAccount = {
      userId: user?.id,
      role: "athlete",
      email: user?.email,
      registered: true,
      eventId: 0,
    };

    dispatch(clearRegisterData());
    dispatch(registerAccountStore(registeredAccount));
    localStorage.setItem(
      "registeredAccount",
      JSON.stringify(registeredAccount),
    );
    localStorage.removeItem("subscriptionDetails");
    setTimeout(() => {
      window.location.href = SUBSCRIPTION_ROUTE;
    }, 200);
  }, [dispatch, user?.id, user?.email]);
};
